/**
 * 金额相关工具类
 */

/**
 * 如果金额超过 10000，则将其转化为 x.xxw 的格式；
 * 如果金额在 10000 以内，则将其保持为实际金额，保留两位小数。
 * 例如：
 *  当金额为 9999，返回 9999.00。
 *  当金额为 10000，返回 1.00w。
 *  当金额为 15000，返回 1.50w。
 *  当金额为 1234567，返回 123.46w。
 * @param amount
 * @returns {string|*|string|string}
 */
export function formatAmountToW(amount) {
  const isOverTenThousand = amount >= 10000;

  if (isOverTenThousand) {
    // 超过10000的金额按 "x.xxw" 格式化
    let truncatedValue = Math.floor(amount / 100) / 100;
    return truncatedValue + 'w';
  } else {
    // 保持实际金额，截断小数部分而不是四舍五入
    let truncatedValue = Math.floor(amount * 100) / 100;
    return truncatedValue.toFixed(2);
  }
}
